module.exports = __webpack_public_path__ + "static/media/hsf.35d84133.png";